import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Hide the store-switch skeleton (if it was shown) now that React has mounted
try {
  localStorage.removeItem('storeSwitching');
  const skeleton = document.getElementById('store-switch-skeleton');
  if (skeleton) skeleton.style.display = 'none';
} catch (e) {}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();